import React from 'react';

export const LoadingContainer = ({ ...otherProps }) => {
  return (
    <div className=' loading-overlay' {...otherProps}>
      <div className='loading'></div>
    </div>
  );
};
